import { createPublicClient, http } from "viem";
import { avalanche } from "viem/chains";

const publicClient = createPublicClient({
  chain: avalanche,
  transport: http(),
});

const getBalance = async (walletAddress: `0x${string}`, tokenAddress?: `0x${string}`) => {
  if (!walletAddress) return null;

  try {
    if (!tokenAddress) {
      return await publicClient.getBalance({ address: walletAddress });
    }
    return await publicClient.readContract({
      address: tokenAddress,
      abi: [
        {
          type: "function",
          name: "balanceOf",
          stateMutability: "view",
          inputs: [{ name: "account", type: "address" }],
          outputs: [{ type: "uint256" }],
        },
      ],
      functionName: "balanceOf",
      args: [walletAddress],
    });
  } catch (error) {
    console.error("Lỗi khi lấy balance:", error);
    return null;
  }
};

export default getBalance;
